export interface PaymentMethod {
  value: string;
  label: string;
  color: string;
}

export const paymentMethods = [
  { value: "bank-transfer", label: "Bank Transfer", color: "#4CAF50" },
  { value: "mtn-mobile-money", label: "MTN Mobile Money", color: "#FFC107" },
  { value: "telecash", label: "Telecash", color: "#2196F3" },
  { value: "airteltigo-cash", label: "Airteltigo Cash", color: "#F44336" },
  { value: "m-pesa", label: "M-pesa", color: "#9C27B0" },
  { value: "mobile-money", label: "Mobile Money", color: "#FF9800" },
  { value: "zelle", label: "Zelle", color: "#673AB7" },
  { value: "revolut", label: "Revolut", color: "#03A9F4" },
  { value: "fidelity-bank", label: "Fidelity Bank", color: "#E91E63" },
] as const;

export type PaymentMethodType = (typeof paymentMethods)[number];
